import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import SignUp from '../../components/Signup-login/signup.vue';
import Login from '../../components/Signup-login/login.vue';

type Emits = {
	(e: 'close'): void
}
enum stages{
	signup = 1,
	login = 2,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-popup',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const mode = ref(stages.login);

const __returned__ = { emit, stages, mode, ref, SignUp, Login }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})